//#region import
import React, { Fragment, createContext, useContext, useEffect, useRef, useState } from 'react';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, DefaultArrayEmpty, Extension, FnAxios, FnDialog, I18n, IsNullOrUndefined, ParseHtml } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPanel, EnumProjectStatusID, EnumSaveModeProject, EnumStatusMode, I18NextNs } from 'enum/enum';
import { ApiProject } from 'enum/api';
import { Chip, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { BtnAdd, BtnCancel, BtnDraft, BtnEdit, BtnSave, BtnSend, BtnSendRequest } from 'components/Button/ButtonAll';
import ErrorIcon from '@mui/icons-material/Error';
import { FormProvider, useForm } from 'react-hook-form';
import { TextBoxItem } from 'components/Input/TextBox';
import { RadioListItem } from 'components/Input/Radio';
import { SelectItem } from 'components/Input/Select/SelectItem';
import MapComponents from 'view/Map/MapComponents';
import UploadFileItem from 'components/Input/UploadFile';
import { TextAreaItem } from 'components/Input/TextArea';
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import AccordionPanel from '../components/AccordionPanel';
import { useLocation } from 'react-router';
import InputNumberItem from 'components/Input/InputNumber';
//#endregion

const Panel4 = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        isSubmit,
        setisSubmit,
        ObjStepFlowProject,
        isModeSecretary,
        nProgressStatusID,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    
    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [isComplete, setisComplete] = useState(null);
    const [arrProvince, setarrProvince] = useState([]);
    const [arrDistrict, setarrDistrict] = useState([]);
    const [arrSubDistrict, setarrSubDistrict] = useState([]);
    const [arrTypeLocationID, setarrTypeLocationID] = useState<any>([{ label: "เลือกจากแผนที่", value: 1, }, { label: "ระบุ ละติจูด/ลองจิจูด", value: 2 }]); //1 = แผนที่, 2 = ระบุละติจูด/ลองจิจูด    
    const [isLocationOption, setisLocationOption] = useState(true);
    const mapRefArea = useRef(null);
    const [sSearchMap, setSearchMap] = useState(null);
    const [sProvinceName, setProvinceName] = useState(null);
    const [latSearch, setlatSearch] = useState(null);
    const [lngSearch, setlngSearch] = useState(null);
    const [oMarkerArea, setoMarkerArea] = useState(null);
    const [arrMarker, setarrMarker] = useState([]);
    const onClearFile = useRef(null);
    const [arrFileDocumentArea, setFileDocumentArea] = useState([]);
    
    const [nAreaIDEdit, setnAreaIDEdit] = useState(0);
    const [ObjAreaIDEdit, setObjAreaIDEdit] = useState(null);
    const [arrProjectArea, setarrProjectArea] = useState([]);
    const [DataRowArea, setDataRowArea] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sAreaName: null,
            nProvinceID_Area: null,
            nDistrictID_Area: null,
            nSubDistrictID_Area: null,
            nLocationOptionID: 1,
            sLatitude_Fill: null,
            sLongitude_Fill: null,
            sLatitude: null,
            sLongitude: null,
            sLocation: null,
            sLocationDesc: null,
        } as any,
    });

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);

    useEffect(() => {
        onGetProvince();
    }, []);

    useEffect(() => {
        if (nProjectID !== 0) handleGetFormProjectID();
    }, [nProjectID]);

    const handleGetFormProjectID = () => {
        // DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetFormProjectID_Panel4, { nProjectID : nProjectID }, (result) => {
            // DialogFn.UnBlockUI();
            setnProjectID(result.objResult.nProjectID);
            // setnStatusID(result.objResult.nStatusID);
            setisComplete(result.objResult.isComplete);
            setarrProjectArea(result.objResult.lstObjProjectArea);
            setDataRowArea({
                ...initRows,
                nDataLength: result.objResult.lstObjProjectArea.length,
                arrRows: result.objResult.lstObjProjectArea,
            });
        });
    };
    
    const onGetProvince = () => {
        form.setValue("nSubDistrictID_Area", null);
        form.setValue("nDistrictID_Area", null);
        DialogFn.BlockUI();
        AxiosFn.Get(ApiProject.GetProvinceData, {}, (result) => {
            if (result.nStatusCode === APIStatusCode.Success) {
                setarrProvince(result.Data.lstTMProvince);
            }
            DialogFn.UnBlockUI();
        },(err) => {
            DialogFn.UnBlockUI();
        });
    };

    const onGetDistrict = (nProvinceID) => {
        form.setValue("nSubDistrictID_Area", null);
        if (nProvinceID) {
            DialogFn.BlockUI();
            AxiosFn.Get(ApiProject.GetDistrictData, { nProvinceID: parseInt(nProvinceID) } , (result) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    setarrDistrict(result.Data.lstTMDistrict);
                }
                DialogFn.UnBlockUI();
            },(err) => {
                DialogFn.UnBlockUI();
            });
        } else {
            setarrDistrict([]);
        }
    };

    const onGetSubDistrict = (nDistrictID) => {
        if (nDistrictID) {
            DialogFn.BlockUI();
            AxiosFn.Get(ApiProject.GetSubDistrictData, { nDistrictID: parseInt(nDistrictID) } , (result) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    setarrSubDistrict(result.Data.lstTMSubDistrict);
                }
                DialogFn.UnBlockUI();
            },(err) => {
                DialogFn.UnBlockUI();
            });           
        } else {
            setarrSubDistrict([]);
        }
    };
    
    const dataColumnArea : any = [
        {
            field: "isEdit",
            // headerName: `${I18n.SetText("Project.sManagement")}`,
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [
                    !item.row.isEdit && ((isPermission && isModeSecretary !== true) || isEditSecretary === true) ?
                        <>
                            {nStatusID !== EnumProjectStatusID.nStatusID_11 &&
                                <BtnDeleteOnTable
                                    key={"btnDelete_Area_" + item.row.sID}
                                    id={"btnDelete_Area_" + item.row.sID}
                                    onClick={() => onDeleteArea(item.row.nID, EnumStatusMode.Delete)}
                                    IsDisabled={!isPermission || isEditSecretary === false}
                                />
                            }                      
                            <BtnEditOnTable
                                key={"btnEdit_Area_" + item.row.sID}
                                id={"btnEdit_Area_" + item.row.sID}
                                onClick={() => onEditArea(item.row, EnumStatusMode.Edit)}
                                IsDisabled={!isPermission || isEditSecretary === false}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Area_" + item.row.sID}
                            id={"btnView_Area_" + item.row.sID}
                            onClick={() => onEditArea(item.row, EnumStatusMode.View)}
                            // IsDisabled={isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nNo",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sAreaName",
            headerName: "ชื่อพื้นที่",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 6,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sLatitude",
            headerName: "ละติจูด",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {       
                return (
                    <Grid item xs={12} md={12}><Typography>{item.row.nLocationOptionID === 1 ? item.row.sLatitude : item.row.sLatitude_Fill}</Typography></Grid>
                );
            }             
        },
        {
            field: "sLongitude",
            headerName: "ลองจิจูด",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {       
                return (
                    <Grid item xs={12} md={12}><Typography>{item.row.nLocationOptionID === 1 ? item.row.sLongitude : item.row.sLongitude_Fill}</Typography></Grid>
                );
            } 
        },
    ];

    const onAddArea = () => {
        let isCheck = false;
        let oForm = form.getValues();
        if (isLocationOption) {
            let sLatitude = oForm.sLatitude ?? null;
            let sLongitude = oForm.sLongitude ?? null;
            isCheck = (sLatitude != null && sLongitude != null) ? true : false;
        } else {
            let sLatitude_Fill = oForm.sLatitude_Fill ?? null;
            let sLongitude_Fill = oForm.sLongitude_Fill ?? null;
            isCheck = (sLatitude_Fill != null && sLongitude_Fill != null) ? true : false;
        }
        if (isCheck)
        {
            let ObjDuplicate = arrProjectArea.filter((f) => !f.isDelete && (nAreaIDEdit !== 0 ? f.nID !== nAreaIDEdit : true) && f.sAreaName === oForm.sAreaName);
            if ((ObjDuplicate || []).length === 0)
            {  
                //#region Old
                // let nAreaID = 0;
                // let dataRow = DataRowArea;
                // let arrArea = DefaultArrayEmpty(arrProjectArea);
                // let nMaxID = new LINQ<any>(arrArea).Any() ? new LINQ<any>(arrArea).Max((m) => m.nID) + 1 : 1;
                // if (nAreaIDEdit) {
                //     arrArea = arrArea.filter((f) => f.nID !== nAreaIDEdit);
                //     nAreaID = arrProjectArea.find((f) => f.nID === nAreaIDEdit)?.nAreaID;
                //     nMaxID = nAreaIDEdit;
                // }
                // let obj = {
                //     isDelete: false,
                //     isEdit: false, 
                //     sID: nMaxID.toString(),
                //     nNo: nMaxID,
                //     nID: nMaxID,
                //     nAreaID: nAreaID,
                //     sAreaName: oForm.sAreaName,
                //     nProvinceID: Convert.StringToInt(oForm.nProvinceID_Area),
                //     nDistrictID: Convert.StringToInt(oForm.nDistrictID_Area),
                //     nSubDistrictID: Convert.StringToInt(oForm.nSubDistrictID_Area),
                //     nLocationOptionID: Convert.StringToInt(oForm.nLocationOptionID),
                //     sLatitude_Fill: !isLocationOption ? oForm.sLatitude_Fill : null,
                //     sLongitude_Fill: !isLocationOption ? oForm.sLongitude_Fill : null,
                //     sLatitude: isLocationOption ? oForm.sLatitude + "" : null,
                //     sLongitude: isLocationOption ? oForm.sLongitude + "" : null,
                //     sLocation: oForm.sLocation,     
                //     sLocationDesc: oForm.sLocationDesc,           
                //     lstFileDocumentArea: arrFileDocumentArea ?? [],       
                // };

                // let nNo = 1;
                // let result = [...arrArea, obj];
                // // result.forEach(f => f.nNo = nNo++);
                // result.forEach(f => {
                //     if (f.isDelete === true) {
                //         f.nNo = 0;
                //     } else {
                //         f.nNo = nNo++;
                //     }
                // });
                // let arrTable = result.filter(f => !f.isDelete);
                // setDataRowArea({
                //     ...dataRow,
                //     nDataLength: arrTable.length,
                //     arrRows: arrTable,
                // });
                // setnAreaIDEdit(0);
                // setObjAreaIDEdit([]);
                // setarrProjectArea(result);
                // onClearFieldArea();   
                //#endregion
        
                //#region New
                let nAreaID = 0;
                let dataRow = DataRowArea;
                let arrArea = DefaultArrayEmpty(arrProjectArea);

                if (nAreaIDEdit) //Edit
                {
                    const oEditIndex = arrArea.findIndex((item) => item.nID === nAreaIDEdit);
                    if (oEditIndex !== -1) {
                        arrArea[oEditIndex].sAreaName = oForm.sAreaName;
                        arrArea[oEditIndex].nProvinceID = Convert.StringToInt(oForm.nProvinceID_Area);
                        arrArea[oEditIndex].nDistrictID = Convert.StringToInt(oForm.nDistrictID_Area);
                        arrArea[oEditIndex].nSubDistrictID = Convert.StringToInt(oForm.nSubDistrictID_Area);
                        arrArea[oEditIndex].nLocationOptionID = Convert.StringToInt(oForm.nLocationOptionID);
                        arrArea[oEditIndex].sLatitude_Fill = !isLocationOption ? oForm.sLatitude_Fill : null;
                        arrArea[oEditIndex].sLongitude_Fill = !isLocationOption ? oForm.sLongitude_Fill : null;
                        arrArea[oEditIndex].sLatitude = isLocationOption ? oForm.sLatitude + "" : null;
                        arrArea[oEditIndex].sLongitude = isLocationOption ? oForm.sLongitude + "" : null;
                        arrArea[oEditIndex].sLocation = oForm.sLocation;     
                        arrArea[oEditIndex].sLocationDesc = oForm.sLocationDesc;           
                        arrArea[oEditIndex].lstFileDocumentArea = arrFileDocumentArea ?? [];       
                    }
                    let arrTable = arrArea.filter(f => !f.isDelete);
                    setDataRowArea({
                        ...dataRow,
                        nDataLength: arrTable.length,
                        arrRows: arrTable,
                    });
                } 
                else //Add
                {            
                    let nMaxID = new LINQ<any>(arrArea).Any() ? new LINQ<any>(arrArea).Max((m) => m.nID) + 1 : 1;                   
                    let obj = {
                        isDelete: false,
                        isEdit: false, 
                        sID: nMaxID.toString(),
                        nNo: nMaxID,
                        nID: nMaxID,
                        nAreaID: nAreaID,
                        sAreaName: oForm.sAreaName,
                        nProvinceID: Convert.StringToInt(oForm.nProvinceID_Area),
                        nDistrictID: Convert.StringToInt(oForm.nDistrictID_Area),
                        nSubDistrictID: Convert.StringToInt(oForm.nSubDistrictID_Area),
                        nLocationOptionID: Convert.StringToInt(oForm.nLocationOptionID),
                        sLatitude_Fill: !isLocationOption ? oForm.sLatitude_Fill : null,
                        sLongitude_Fill: !isLocationOption ? oForm.sLongitude_Fill : null,
                        sLatitude: isLocationOption ? oForm.sLatitude + "" : null,
                        sLongitude: isLocationOption ? oForm.sLongitude + "" : null,
                        sLocation: oForm.sLocation,     
                        sLocationDesc: oForm.sLocationDesc,           
                        lstFileDocumentArea: arrFileDocumentArea ?? [],       
                    };

                    let nNo = 1;
                    let result = [...arrArea, obj];
                    // result.forEach(f => f.nNo = nNo++);
                    result.forEach(f => {
                        if (f.isDelete === true) {
                            f.nNo = 0;
                        } else {
                            f.nNo = nNo++;
                        }
                    });
                    let arrTable = result.filter(f => !f.isDelete);
                    setDataRowArea({
                        ...dataRow,
                        nDataLength: arrTable.length,
                        arrRows: arrTable,
                    });
                    setarrProjectArea(result);
                }
                setnAreaIDEdit(0);
                setObjAreaIDEdit([]);
                onClearFieldArea();   
                //#endregion          
            }
            else {
                DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
            }
        }
        else
        {
            DialogFn.Warning("กรุณาระบุ ข้อมูลสถานที่ โดยการเลือกในแผนที่");
        }
    };

    const onClearFieldArea = () => {
        Object.keys(form.getValues()).forEach((key) => {
            form.setValue(key, null);
            form.clearErrors(key);
        });
        form.setValue("nLocationOptionID", 1);
        setisLocationOption(true);
        setFileDocumentArea([]);
        onClearFile.current();
        onGetProvince();

        setarrMarker([]);
        setoMarkerArea(null);
        setlatSearch(null);
        setlngSearch(null);  
        setSearchMap(null);  
    };

    const onEditArea = (ObjData, nModeID : EnumStatusMode) => {
        setoMarkerArea(null);
        setFileDocumentArea([]);
        onClearFile.current();
        onGetDistrict(ObjData.nProvinceID);
        onGetSubDistrict(ObjData.nDistrictID);
        setnAreaIDEdit(ObjData.nID);
        let ObjArea = {
            isDelete: ObjData.isDelete,
            isEdit: true, 
            sID: ObjData.sID,
            nNo: ObjData.nID,
            nID: ObjData.nID,
            nAreaID: ObjData.nAreaID,
            sAreaName: ObjData.sAreaName,
            nProvinceID: ObjData.nProvinceID,
            nDistrictID: ObjData.nDistrictID,
            nSubDistrictID: ObjData.nSubDistrictID,
            nLocationOptionID: ObjData.nLocationOptionID,
            sLatitude_Fill: ObjData.sLatitude_Fill,
            sLongitude_Fill: ObjData.sLongitude_Fill,
            sLatitude: ObjData.sLatitude,
            sLongitude: ObjData.sLongitude,
            sLocation: ObjData.sLocation,     
            sLocationDesc: ObjData.sLocationDesc,           
            lstFileDocumentArea: ObjData.lstFileDocumentArea,       
        };        
        setObjAreaIDEdit(ObjArea);
        form.setValue("sAreaName", ObjArea.sAreaName);
        form.setValue("nProvinceID_Area", ObjArea.nProvinceID);
        form.setValue("nDistrictID_Area", ObjArea.nDistrictID);
        form.setValue("nSubDistrictID_Area", ObjArea.nSubDistrictID);
        form.setValue("nLocationOptionID", ObjArea.nLocationOptionID);
        setisLocationOption(ObjArea.nLocationOptionID === 1);
        form.setValue("sLatitude_Fill", ObjArea.sLatitude_Fill);
        form.setValue("sLongitude_Fill", ObjArea.sLongitude_Fill);
        form.setValue("sLatitude", ObjArea.sLatitude);
        form.setValue("sLongitude", ObjArea.sLongitude);
        form.setValue("sLocation", ObjArea.sLocation);
        form.setValue("sLocationDesc", ObjArea.sLocationDesc);
        setFileDocumentArea(ObjArea.lstFileDocumentArea);
        if(ObjArea.nLocationOptionID === 1){
            // let arr = [{ lat: Convert.StringToFloat(ObjArea.sLatitude), lng: Convert.StringToFloat(ObjArea.sLongitude) },];
            // setarrMarker(arr);  
            // setoMarkerArea(ObjArea.sLocation);
            setlatSearch(ObjArea.sLatitude);
            setlngSearch(ObjArea.sLongitude);
        }

        document.getElementById("myDivArea").scrollIntoView({ behavior: "smooth" });
    }

    const onDeleteArea = (nID, nModeID : EnumStatusMode) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrAreaData: any[] = arrProjectArea;
            let result = arrAreaData.filter((f) => f.nID !== nID);
            let arrDelete = arrAreaData.filter((f) => f.nID === nID);
            arrDelete.forEach(item => {
                item.isDelete = true;
                item.nNo = 0;
            })
            let nNo = 1;
            result.filter(f => !f.isDelete).forEach((f) => {
                f.nNo = nNo++;
            });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowArea({
                ...DataRowArea,
                nDataLength: result.filter(f => !f.isDelete).length,
                arrRows: [...result.filter(f => !f.isDelete)],
            });
            setarrProjectArea([...result, ...arrDelete]);
        });
    };

    const handleSubmit = (nModeID: EnumSaveModeProject) => {
        if (arrProjectArea.filter(f => !f.isDelete).length === 0 && nModeID === EnumSaveModeProject.Submit) {
            return DialogFn.Warning("กรุณาเพิ่มข้อมูลอย่างน้อย 1 รายการ");
        } 
        let param = {
            nProjectID: nProjectID,
            nSaveModeProject: nModeID,
            nPanelID: EnumProjectPanel.Panel4,
            isFastTrack: isFastTrack,

            lstObjProjectArea: arrProjectArea,

            sLocation: location.pathname,
        };
        DialogFn.Submit(nModeID === EnumSaveModeProject.Draft
                        ? I18n.SetText("Message.ConfirmSaveDraft", I18NextNs.labelComponent) 
                        : I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPanel4, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success( I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        setnProjectID(result.objResult?.nProjectID);
                        setisComplete(nModeID === EnumSaveModeProject.Draft ? false : true);
                        // setarrisEditPanel({nPanelID: 4, isEdit: false});
                        setisSubmit(isSubmit === true ? false : true);
                        if(isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    return (
        <AccordionPanel
            header={"4. พื้นที่ดำเนินการ"}
            isExpanded={true} 
            // SubHeader={}
            color="white"
            bgColor="rgb(102,151,245)"
            background="#5598fc"
            expandIconColor="white"
            borderColor="1px solid #5598fc"
            borderRadius="18px !important"
            boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
            boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"
            SubHeaderStatus={
                (isComplete !== null &&
                    <Chip
                        size="small"
                        label={ParseHtml(isComplete === false ? 'บันทึกร่าง' : isComplete === true ? "บันทึกพร้อมส่ง" : "")}
                        style={{
                            color: "white",
                            backgroundColor: (isComplete === false ? '#f18c3a' : isComplete === true ? "#0a9914" : ""),
                            fontSize: "14px"
                        }}
                    />     
                )      
            }
            isDisabled={nProjectID === 0}
        >        
            <Grid id={"myDivArea"} item xs={12} md={12} container spacing={1} style={{ padding: '2%', paddingBottom: '1%', }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <Grid item>
                                <Typography variant='h6' color={'#0000a5'}>พื้นที่ดำเนินการ</Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip placement={'right-end'} title={"ระบุที่ตั้ง ขนาด หรือขอบเขดพื้นที่ดำเนินโครงการให้ชัดเจนในระดับตำบล อำเภอ จังหวัด ให้ครบถ้วน พร้อมทั้งแสดงพิกัดตำแหน่ง ทั้งที่เป็นค่าตัวเลข (ละติจูด/ลองจิจูด) และแผนที่ให้ชัดเจน"} >
                                    <ErrorIcon color='primary'/>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider />
                            </Grid>
                        </Grid>                    
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                            <Grid item xs={12} md={12}>
                                <TextBoxItem
                                    id={"sAreaName"}
                                    name={"sAreaName"}
                                    type={"text"}
                                    label={"ชื่อพื้นที่"}
                                    required={true}
                                    maxLength={250}
                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                />
                            </Grid> 
                            <Grid item xs={12} md={4}>
                                <SelectItem
                                    id="nProvinceID_Area"
                                    name="nProvinceID_Area"
                                    options={arrProvince}
                                    label={"จังหวัด"}
                                    placeholder="เลือกจังหวัด"
                                    required={true}
                                    onChange={(e) => {
                                        onGetDistrict(e?.value);
                                        setProvinceName(e?.label);
                                        setSearchMap(e?.label);
                                    }}
                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <SelectItem
                                    id="nDistrictID_Area"
                                    name="nDistrictID_Area"
                                    options={arrDistrict}
                                    label={"อำเภอ"}
                                    placeholder="เลือกอำเภอ"
                                    required={true}
                                    onChange={(e) => {
                                        onGetSubDistrict(e?.value);
                                        setSearchMap(sProvinceName + " " + e?.label);
                                    }}
                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <SelectItem
                                    id="nSubDistrictID_Area"
                                    name="nSubDistrictID_Area"
                                    options={arrSubDistrict}
                                    label={"ตำบล"}
                                    placeholder="เลือกตำบล"
                                    required={true}
                                    onChange={(e) => {
                                        setSearchMap(sProvinceName + " " + e?.label);
                                    }}
                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <RadioListItem
                                    id={"nLocationOptionID"}
                                    name={"nLocationOptionID"}
                                    label={"สถานที่"}
                                    IsNotShowLabel={false}
                                    required={true}
                                    options={arrTypeLocationID}    
                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}  
                                    onChange={(e)=> {
                                        let nValue = Convert.StringToInt(e);
                                        setisLocationOption(nValue === 1);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} container spacing={2} style={{ display: (!isLocationOption ? "" : "none"),}}>
                                <Grid item xs={12} md={6}>
                                    {/* <TextBoxItem
                                        id="sLatitude_Fill" //กรอกเอง
                                        name="sLatitude_Fill"
                                        maxLength={50}
                                        isTelNo={true}
                                        pattern={'en-number'}
                                        label="ละติจูด"
                                        // placeholder="ละติจูด"
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                        required={isLocationOption === false}
                                    /> */}
                                    <InputNumberItem
                                        id={"sLatitude_Fill"} //กรอกเอง
                                        name={"sLatitude_Fill"}
                                        label={"ละติจูด"}
                                        IsComma={false}
                                        IsAllowScientific={true} //ใช้มีลักษณะพิเศษได้
                                        type={"Number"}
                                        maxInteger={50}
                                        maxLength={50}                                            
                                        required={isLocationOption === false}
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    {/* <TextBoxItem                                            
                                        id="sLongitude_Fill"
                                        name="sLongitude_Fill"
                                        maxLength={50}
                                        isTelNo={true}
                                        pattern={'en-number'}
                                        label="ลองจิจูด"
                                        // placeholder="ลองจิจูด"
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                        required={isLocationOption === false}
                                    /> */}
                                    <InputNumberItem
                                        id={"sLongitude_Fill"} //กรอกเอง
                                        name={"sLongitude_Fill"}
                                        label={"ลองจิจูด"}
                                        IsComma={false}
                                        IsAllowScientific={true} //ใช้มีลักษณะพิเศษได้
                                        type={"Number"}
                                        maxInteger={50}
                                        maxLength={50}
                                        required={isLocationOption === false}
                                        disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={2} style={{ display: (isLocationOption ? "" : "none"),}}>
                                <Grid item xs={12} md={12}>
                                    {/* display={"none"} */}
                                    <TextBoxItem
                                        id="sLocation"
                                        name="sLocation"
                                        maxLength={500}
                                        // label="Path Map"
                                        label="ระบบแสดงข้อมูลจากที่เลือกในแผนที่"
                                        required={false}
                                        disabled={true}
                                        IsShowTextCont={false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextBoxItem
                                            id="sLatitude"
                                            name="sLatitude"
                                            maxLength={50}
                                            label="ละติจูด"
                                            // placeholder="ละติจูด"
                                            required={false}
                                            disabled={true}
                                            onBlur={(e) => {
                                                setlatSearch(e);
                                            }}
                                            IsShowTextCont={false}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextBoxItem
                                            id="sLongitude"
                                            name="sLongitude"
                                            maxLength={50}
                                            label="ลองจิจูด"
                                            // placeholder="ลองจิจูด"
                                            required={false}
                                            disabled={true}
                                            onBlur={(e) => {
                                                setlngSearch(e);
                                            }}
                                            IsShowTextCont={false}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    {(isEditSecretary === true || (isPermission && isModeSecretary !== true)) ?
                                        (nStatusID !== EnumProjectStatusID.nStatusID_11 &&
                                            <MapComponents
                                                id={"div-area"}
                                                mapRef={mapRefArea}
                                                IsMultiMarker={false}
                                                Isdisable={false}
                                                IsMarker={true}
                                                IsPopUp={true}
                                                IsSearch={true}
                                                form={form}
                                                arrMarker={arrMarker}
                                                setarrMarker={setarrMarker}
                                                markerSearch={oMarkerArea}
                                                setmarkerSearch={setoMarkerArea}
                                                sSearch={sSearchMap}
                                                latSearch={latSearch}
                                                lngSearch={lngSearch}
                                                nZoomClick={13}
                                            />
                                        )
                                        :
                                        <MapComponents
                                            id={"div-area-view"}
                                            mapRef={mapRefArea}
                                            IsMultiMarker={false}
                                            Isdisable={false}
                                            IsMarker={false}
                                            IsPopUp={true}
                                            IsSearch={false}
                                            IsFullScreen={false}
                                            // sHeight={"300px"}
                                            arrMarker={arrMarker}
                                            setarrMarker={setarrMarker}
                                            // markerSearch={oMarkerArea}
                                            // setmarkerSearch={setoMarkerArea}
                                            // sSearch={sSearchMap}
                                            // latSearch={latSearch}
                                            // lngSearch={lngSearch}
                                        />
                                }
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TextAreaItem
                                    id={"sLocationDesc"}
                                    name={"sLocationDesc"}
                                    label={"คำอธิบายเพิ่มเติม"}                               
                                    required={false}
                                    maxLength={500}
                                    row={3}
                                    disabled={(nStatusID === EnumProjectStatusID.nStatusID_11) ? true : !isPermission || isEditSecretary === false}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <UploadFileItem
                                    required={false}
                                    modeDisplay={"list"}
                                    id={"oFileArea"}
                                    name={"oFileArea"}
                                    label={"แนบไฟล์แผนที่ แสดงพื้นที่ดำเนินโครงการ"}
                                    arrFile={arrFileDocumentArea}
                                    setarrFile={setFileDocumentArea}
                                    Extension={Extension.ImageDocument}
                                    IsFolder={false}
                                    onClearFile={onClearFile}
                                    sFolderTemp="Project"
                                    IsMultiple={true}
                                    nLimitFile={10}
                                    sLimitFile="MB"
                                    sPositionText="right"
                                    IsCrop={true}
                                    cropShape={"retangle"}
                                    cropRatio={16 / 9}
                                    cropResize={true}
                                    cropMovable={true}
                                    disabled={!isPermission || isEditSecretary === false}
                                />
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end" style={{ paddingBottom: '1%', }}>
                                {/* <BtnAdd id={"btnAdd"} txt={"เพิ่มพื้นที่ดำเนินการ"} onClick={form.handleSubmit((e) => onAddArea(),(err) => console.log("err", err))} /> */}
                                {(nAreaIDEdit === 0 && ((isPermission && isModeSecretary !== true) || isEditSecretary === true)) ?
                                    (nStatusID !== EnumProjectStatusID.nStatusID_11 &&
                                        <BtnAdd id={"btnAdd_Table_Area"} IsDisabled={!isPermission || isEditSecretary === false} txt={"เพิ่มพื้นที่ดำเนินการ"} onClick={form.handleSubmit((e) => onAddArea(),(err) => console.log("err", err))} />
                                    )
                                    :
                                    <>
                                        {((isPermission && isModeSecretary !== true) || isEditSecretary === true) &&
                                            <Grid item>
                                                <BtnSave id={"btnSave_Table_Area"} IsDisabled={!isPermission || isEditSecretary === false} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={form.handleSubmit((e) => onAddArea(),(err) => console.log("err", err))} />
                                            </Grid>
                                        }
                                        {nAreaIDEdit !== 0 &&
                                            <Grid item>
                                                <BtnCancel id={"btnCancel_Table_Area"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnAreaIDEdit(0); setObjAreaIDEdit(null); onClearFieldArea(); }} />
                                            </Grid>
                                        }              
                                    </>
                                }
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <DataGrid
                                    sTableID='TB_ProjectArea'
                                    columns={dataColumnArea}
                                    rows={DataRowArea}
                                    isShowColomnTool={false}
                                    isHiddenToolHead={true}
                                    isShowCheckBox={false}
                                    isHiddenPagination={true}
                                    // onDelete={onDeleteArea}
                                    // onRowSelectable={(params) => params.row.nID !== nAreaIDEdit}
                                />
                            </Grid>
                        </Grid>  
                        <Grid item xs={12} md={12} container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Typography variant='body1'>หมายเหตุ</Typography>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                <Grid item xs={12} md={11.8}>
                                    <Grid item>
                                        <Typography variant='body2'>{"๑) พื้นที่ดําเนินการควรเป็นพื้นที่ที่อยู่ในบัญชีแหล่งซากดึกดําบรรพ์เพื่อการดําเนินการตามกฎหมาย ฉบับที่ ๓ หากพื้นที่โครงการไม่ได้อยู่ในบัญชีดังกล่าว โครงการของท่านจะถูกพิจารณาจัดลําดับความสําคัญลดลง"}</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant='body2'>{"๒) กรณีที่พื้นที่ดําเนินการเป็นพื้นที่อนุรักษ์และคุ้มครองตามระเบียบ/กฎหมายของหน่วยงานราชการ ผู้ขอรับการสนับสนุนจากกองทุนฯ ต้องแสดงหนังสืออนุญาต/ยินยอมให้เข้าพื้นที่และเก็บตัวอย่างจากหน่วยงานดังกล่าวด้วย ทั้งนี้ สามารถตรวจสอบข้อมูล โดยการประสานงานกับหน่วยงานต่าง ๆ ที่เกี่ยวข้องกับพื้นที่โครงการ เช่น หน่วยงานราชการท้องถิ่น กรมป่าไม้ สํานักงานปฏิรูปที่ดินเพื่อเกษตรกรรม กรมทรัพยากรธรณี และกรมอุทยาน สัตว์ป่า และพันธุ์พืช เป็นต้น"}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid> 
                        {(nProjectID === 0 || nProgressStatusID === EnumProjectStatusID.nStatusID_28) ?
                            <></>  
                            :
                            (isPermission === true &&
                                (isModeSecretary !== true ?
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        {nStatusID === EnumProjectStatusID.nStatusID_0 &&
                                            <Grid item>
                                                <BtnDraft id={"btnDraft_Panel4"} txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Draft) }} />
                                            </Grid>
                                        }
                                        <Grid item>
                                            <BtnSendRequest id={"btnSend_Panel4"} txt={I18n.SetText((nStatusID === EnumProjectStatusID.nStatusID_0 ? "Button.SendProjectPanel" : "Button.Save"), I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit) }} />
                                        </Grid> 
                                    </Grid> 
                                : 
                                    (isModeSecretary === true ?
                                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                            {isEditSecretary === false ?
                                                <Grid item>
                                                    <BtnEdit id={"btnEdit_Panel4"} txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivArea").scrollIntoView({ behavior: "smooth" });}} />
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item>
                                                        <BtnCancel id={"btnCancel_Panel4"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); handleGetFormProjectID(); }} />
                                                    </Grid>
                                                    <Grid item>
                                                        <BtnSendRequest id={"btnSend_Panel4"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.Submit); }} />
                                                    </Grid>
                                                </>
                                            }   
                                        </Grid>
                                        : <></>
                                    )
                                )
                            )
                        }      
                    </Grid>                        
                </FormProvider>
            </Grid>   
        </AccordionPanel>
    )
}
export default Panel4;
